<template>
  <div v-show="liveCoachChatVisible" :class="$style.container">
    <h1>Live Coaching</h1>

    <back-to-call
      @click="hideLiveCoachChat"
      :name="contactName || contactNumber"
      :photoUrl="contactPhotoUrl" />

    <chat-window :focus="liveCoachChatVisible" :activity="activity" :request-url="requestUrl"/>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import ChatWindow from '@/components/shared/chat-window/chat-window'
  import BackToCall from '../shared/back-to-call/back-to-call'
  import { jiminnyHost } from '@/helpers/region'

  const { mapState, mapGetters, mapActions } = createNamespacedHelpers('conference')

  export default {
    components: {
      BackToCall,
      ChatWindow
    },
    computed: {
      ...mapState([
        'liveCoachChatVisible',
        'activity'
      ]),
      ...mapGetters([
        'contactName',
        'contactNumber',
        'contactPhotoUrl'
      ]),
      requestUrl () {
        return `${jiminnyHost()}/api/v1/activity/softphone/${this.activity.id}/message`
      }
    },
    methods: mapActions([
      'hideLiveCoachChat'
    ])
  }
</script>

<style module lang="less" src="./live-coach-chat.less"></style>



// WEBPACK FOOTER //
// live-coach-chat.vue?0a640f32